import type { DiamAuditLog } from '../../diamApi';
import { EMPTY_TEAM_NAME } from '../RoleDetails/constants';
import type { AuditLogRow } from './types';

export function mapApiAuditLog(auditLog: DiamAuditLog): AuditLogRow {
  const teamName =
    auditLog.team?.name?.trim() || auditLog.teamId?.trim() || EMPTY_TEAM_NAME;

  return {
    id: auditLog.id,
    createdByName: auditLog.createdByName ?? '',
    createdDate: auditLog.createdDate,
    teamName,
    applicationNames: (auditLog.team?.applicationNames ?? []).filter(Boolean),
    action: auditLog.action,
    resourceType: auditLog.resourceType,
  };
}
